import axios from 'axios';

export class SvgService{
    public async getAll(): Promise<{[key: string]: string}>{
        const result = await axios.get(`/api/svg`);
        return result.data;
    }
}